import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

import type { DecisionMakerResponsesQuery } from '../api.graphql';

export type DecisionMakerResponsesItem = NonNullable<
	DecisionMakerResponsesQuery['decisionMaker']
>['responsesConnection']['nodes'][0];

export type DecisionMakerPageDataErrorCode = 'decision_maker_page_data_not_found';
export class DecisionMakerPageDataError extends PageDataError<DecisionMakerPageDataErrorCode> {}
setClassName(DecisionMakerPageDataError, 'DecisionMakerPageDataError');
